import React, { useState, useEffect } from "react";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../../components/Component";

import LogoDark from "../../../images/logo-dark.png";
import { Form, FormGroup, Spinner, Alert } from "reactstrap";
import PageContainer from "../../../layout/page-container/PageContainer";
import Head from "../../../layout/head/Head";
import AuthFooter from "../AuthFooter";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Logo from "../../../img/Logo.png";
import "../auth-theme.css";

// NOTE: UI-only recreation of the ERP login page. The CIAM/axios/noser.dataaccess
// auth logic from the source has been intentionally removed (no backend wiring).
const Login = () => {
  const { errors, register, handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");
  const [value1, setValue1] = useState("");
  const [value2, setValue2] = useState("");
  const [value3, setValue3] = useState("");

  const handleSname = (event) => {
    setValue1(event.target.value);
  };
  const handleUserId = (event) => {
    setValue2(event.target.value);
  };
  const handlePassword = (event) => {
    setValue3(event.target.value);
  };

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  // UI-only submit: no backend call. Briefly show the spinner, then reset.
  const onFormSubmit = () => {
    setLoading(true);
    setError("");
    setTimeout(() => {
      setLoading(false);
    }, 1200);
  };

  return (
    <React.Fragment>
      <Head title="Login" />
      <PageContainer>
        <div className="nz-auth">
          <Block className="nk-block-middle nk-auth-body  wide-xs">
            <div className="brand-logo pb-4 text-center">
              <img src={Logo} width="40" height="40" style={{ margin: "10px" }} alt="logo" />
              <span style={{ color: "#117864", fontSize: "22px", fontWeight: "bold" }}>Noser</span>
            </div>
            <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
              <BlockHead>
                <BlockContent>
                  <BlockTitle tag="h4">Sign In</BlockTitle>
                  <BlockDes>
                    <p></p>
                  </BlockDes>
                </BlockContent>
              </BlockHead>
              {errorVal && (
                <div className="mb-3">
                  <Alert color="danger" className="alert-icon">
                    {" "}
                    <Icon name="alert-circle" /> Unable to login with credentials{" "}
                  </Alert>
                </div>
              )}
              <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
                <FormGroup>
                  <div className="form-label-group">
                    <label htmlFor="sname">Company Code</label>
                  </div>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      id="companycode"
                      name="companycode"
                      ref={register({ required: "This field is required" })}
                      placeholder="Enter Company Code"
                      className="form-control-m form-control"
                      onChange={handleSname}
                    />
                    {errors.companycode && <span className="invalid">{errors.companycode.message}</span>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="form-label-group">
                    <label className="form-label" htmlFor="userid">
                      User ID
                    </label>
                  </div>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      id="userid"
                      name="userid"
                      autoComplete="off"
                      ref={register({ required: "This field is required" })}
                      placeholder="Enter User ID"
                      className="form-control-m form-control"
                      value={value2.userid}
                      onChange={handleUserId}
                    />
                    {errors.userid && <span className="invalid">{errors.userid.message}</span>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="form-label-group">
                    <label className="form-label" htmlFor="passcode">
                      Password
                    </label>
                    <Link
                      className="link link-primary link-sm"
                      to={{ pathname: "http://152.42.219.109:3000/erp-forgot-password" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Forgot Password?
                    </Link>
                  </div>
                  <div className="form-control-wrap">
                    <a
                      href="#password"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setPassState(!passState);
                      }}
                      className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                    >
                      <Icon name="eye" className="passcode-icon icon-show"></Icon>
                      <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                    </a>
                    <input
                      type={passState ? "text" : "password"}
                      id="passcode"
                      name="passcode"
                      ref={register({ required: "This field is required" })}
                      placeholder="Enter Password"
                      value={value3.passcode}
                      onChange={handlePassword}
                      className={`form-control-m form-control ${passState ? "is-hidden" : "is-shown"}`}
                    />
                    {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
                  </div>
                </FormGroup>
                <FormGroup>
                  <Button size="lg" className="btn-block" type="submit" color="primary">
                    {loading ? <Spinner size="sm" color="light" /> : "Sign In"}
                  </Button>
                </FormGroup>
              </Form>
              <div className="form-note-s2 text-center pt-4">
                {" "}
                New on our platform? <Link to={`${process.env.PUBLIC_URL}/auth-register`}>Create an account</Link>
              </div>
              <div className="text-center pt-4 pb-3">
                <h6 className="overline-title overline-title-sap">
                  <span>OR</span>
                </h6>
              </div>
              <ul className="nav justify-center gx-4">
                <li className="nav-item">
                  <a className="nav-link" href="#socials" onClick={(ev) => ev.preventDefault()}>
                    Facebook
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#socials" onClick={(ev) => ev.preventDefault()}>
                    Google
                  </a>
                </li>
              </ul>
            </PreviewCard>
          </Block>
          <AuthFooter />
        </div>
      </PageContainer>
    </React.Fragment>
  );
};

export default Login;
